module.exports = __webpack_public_path__ + "img/13.04eda109.gif";